import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CommentsSection />
        <RankingSection />
        <ContactSection />
        <AppSection />
        <AboutSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <IndexSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}